import React from "react";
import AllEvents from "../../components/Shop/AllEvents";
import { server } from "../../server";

const ProfileServices = () => {
  return (
    <AllEvents
      entityLabel="Service"
      entityLabelPlural="Services"
      apiBasePath={`${server}/service`}
      apiNamespace="service"
    />
  );
};

export default ProfileServices;
